/*
  FOT — Página de branding "Revolucione seu Movimento"
  Desenvolvido por: Luan Freire - Software Engineer & Shopify Developer

  Duas responsabilidades, nada além disso:

  1. Facade de vídeo. O YouTube só entra na página depois do clique. Antes
     disso o que existe é uma <img> de capa, então nenhum script de terceiro
     compete com o LCP nem infla o TBT.
  2. Copiar o cupom, com fallback para navegadores sem Clipboard API.

  Carregado com defer, uma vez, apenas nesta página.
*/
(function () {
  'use strict';

  function buildEmbedUrl(videoId, startAt) {
    var params = [
      'autoplay=1',
      'rel=0',
      'modestbranding=1',
      'playsinline=1',
      'color=white',
    ];

    if (startAt) params.push('start=' + startAt);

    return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?' + params.join('&');
  }

  function playVideo(trigger) {
    if (trigger.hasAttribute('data-fotb-playing')) return;

    var videoId = trigger.getAttribute('data-fotb-video-id');
    if (!videoId) return;

    var iframe = document.createElement('iframe');
    iframe.src = buildEmbedUrl(videoId, trigger.getAttribute('data-fotb-start'));
    iframe.title = trigger.getAttribute('data-fotb-title') || 'YouTube';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.setAttribute('loading', 'eager');

    trigger.setAttribute('data-fotb-playing', '');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.appendChild(iframe);
    iframe.focus();
  }

  function initVideos(root) {
    root.querySelectorAll('[data-fotb-video-id]').forEach(function (trigger) {
      if (trigger.dataset.fotbBound) return;
      trigger.dataset.fotbBound = 'true';

      trigger.addEventListener('click', function () {
        playVideo(trigger);
      });

      // Pré-conecta ao YouTube no primeiro sinal de intenção, para o
      // clique não pagar o custo de DNS + TLS.
      trigger.addEventListener(
        'pointerenter',
        function () {
          ['https://www.youtube-nocookie.com', 'https://i.ytimg.com'].forEach(function (href) {
            if (document.querySelector('link[rel="preconnect"][href="' + href + '"]')) return;
            var link = document.createElement('link');
            link.rel = 'preconnect';
            link.href = href;
            document.head.appendChild(link);
          });
        },
        { once: true }
      );
    });
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();

      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(field);
      }
    });
  }

  function initCoupons(root) {
    root.querySelectorAll('[data-fotb-coupon]').forEach(function (button) {
      if (button.dataset.fotbBound) return;
      button.dataset.fotbBound = 'true';

      var feedback = document.getElementById(button.getAttribute('aria-describedby') || '');
      var resetTimer;

      button.addEventListener('click', function () {
        var code = button.getAttribute('data-fotb-coupon');

        copyText(code)
          .then(function () {
            if (feedback) feedback.textContent = button.getAttribute('data-fotb-copied') || 'Cupom copiado!';
          })
          .catch(function () {
            if (feedback) feedback.textContent = button.getAttribute('data-fotb-failed') || 'Copie manualmente: ' + code;
          })
          .finally(function () {
            clearTimeout(resetTimer);
            resetTimer = setTimeout(function () {
              if (feedback) feedback.textContent = '';
            }, 4000);
          });
      });
    });
  }

  function init(root) {
    initVideos(root);
    initCoupons(root);
  }

  init(document);

  // O editor de temas recria seções sem recarregar a página.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
